import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title is-narrow is-spaced" }, "Create your account")
  ])
], -1)
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-12" }
const _hoisted_5 = { class: "columns" }
const _hoisted_6 = { class: "column is-narrow" }
const _hoisted_7 = { class: "column is-narrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_outside_account = _resolveComponent("outside-account")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_o_loading, {
      active: _ctx.isSubmitPageLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isSubmitPageLoading) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_icon, {
          pack: "fa",
          icon: "spinner",
          size: "large",
          spin: "",
          variant: "primary"
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _hoisted_2,
    _createVNode(_component_Form, {
      ref: "formValidator",
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_outside_account, {
              ref: "outsideAccount",
              "last-name": _ctx.form.LastName,
              "onUpdate:last-name": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.LastName) = $event)),
              "first-name": _ctx.form.FirstName,
              "onUpdate:first-name": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.FirstName) = $event)),
              "middle-initial": _ctx.form.MI,
              "onUpdate:middle-initial": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.MI) = $event)),
              suffix: _ctx.form.Suffix,
              "onUpdate:suffix": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Suffix) = $event)),
              "email-address": _ctx.form.EmailAddress,
              "onUpdate:email-address": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.EmailAddress) = $event)),
              "user-id": _ctx.form.UserID,
              "onUpdate:user-id": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.UserID) = $event)),
              password: _ctx.form.Password,
              "onUpdate:password": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Password) = $event)),
              "is-User-Id-Available": _ctx.isUserIdAvailable,
              "onUpdate:is-User-Id-Available": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isUserIdAvailable) = $event)),
              isUserIdNotAvailable: !_ctx.isUserIdAvailable,
              isUserIdChecking: _ctx.isUserIdChecking,
              onUseridInput: _ctx.validateUserId,
              isEmailAddressNotAvailable: !_ctx.isEmailAddressAvailable,
              isEmailAddressChecking: _ctx.isEmailAddressChecking,
              onEmailAddressInput: _ctx.validateEmailAddress
            }, null, 8, ["last-name", "first-name", "middle-initial", "suffix", "email-address", "user-id", "password", "is-User-Id-Available", "isUserIdNotAvailable", "isUserIdChecking", "onUseridInput", "isEmailAddressNotAvailable", "isEmailAddressChecking", "onEmailAddressInput"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_o_button, {
              variant: "info",
              class: "is-fullwidth-mobile",
              pack: "fas",
              "icon-left": "search",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Submit ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_o_button, {
              variant: "info",
              class: "is-fullwidth-mobile",
              outlined: "",
              onClick: _ctx.clearfields
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Clear fields ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}